import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-auth",
  "use": "icon-auth-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"icon-auth\">\n<style type=\"text/css\">\n\t#icon-auth .st0{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linejoin:round;}\n\t#icon-auth .st1{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n</style>\n<path class=\"st0\" d=\"M3,4.6L12,2l9,2.6V10c0,5.7-3.6,10.7-9,12.5C6.6,20.7,3,15.7,3,10V4.6z\" />\n<path class=\"st1\" d=\"M7.5,11.5L11,15l6-6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol